export const TRACEPARENT = 'traceparent'
export const TRACE_CONTEXT = 'X-Cloud-Trace-Context'

export function generateTraceRequestHeaders(): { traceId: string; traceContext: string } {
  const cryptoLib: Crypto = typeof window !== 'undefined' ? window.crypto : globalThis.crypto

  const traceId = cryptoLib
    .getRandomValues(new Uint8Array(16))
    .reduce((str, byte) => str + byte.toString(16).padStart(2, '0'), '')

  const spanId = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER) // 64-bit numeric ID

  const traceContext = `${traceId}/${spanId};o=1`

  return { traceId, traceContext }
}
